import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import {
  getRoleListAction,
  getAdminListAction,
} from "../action/roleManagementAction";

export const roleManagementReducer = (
  builder: ActionReducerMapBuilder<{
    roleList: any;
    adminList: any;
  }>
) => {
  builder.addCase(getRoleListAction.fulfilled, (state, { payload }) => {
    state.roleList = payload;
  });
  builder.addCase(getAdminListAction.fulfilled, (state, { payload }) => {
    state.adminList = payload;
  });
};
